<script>
import { orderReportMethods, toasterMethods, userMethods } from '@state/helpers'
import constant from '@constants/constant'

export default {
  props: {
    customerId: {
      type: [Number, String],
      required: true,
    },
    customerUserId: {
      type: [Number, String],
      default: '',
    },
    productId: {
      type: [Number, String],
      default: '',
    },
    customerUserCodeArray: {
      type: Array,
      default() {
        return []
      },
    },

    orderType: {
      type: Number,
      required: true,
    },

    orderID: {
      type: Number,
      required: true,
    },

    orderData: {
      type: Object,
      default() {
        return {}
      },
    },
    orignalOrderData: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      showConfirm: false,
      birthdate: '2019-01-01',
      getCras: [],
      disabled: false,
      isDisabled: false,
      titleHeader: '',
      startdate: '',
      trimergeJsonData: '',
      pageNumber: 1,
      pageSize: 10000,
      title: constant.ccrReportTitle,
      customer: '',
      customerUser: '',
      referenceNumber: '',
      firstName: '',
      middleName: '',
      lastName: '',
      phoneNumber: '',
      email: '',
      suffix: '',
      ssn: '',
      streetAddress: '',
      cityName: '',
      coborrowerFirstName: '',
      coborrowerMiddleName: '',
      coborrowerLastName: '',
      coborrowerPhoneNumber: '',
      ssnValue: 0,
      coborrowerSuffix: '',
      coborrowerStartdate: '',
      signedfile: null,
      PreviousStreetAddress: '',
      propertyStreetAddress: '',
      propertyCityName: '',
      propertyState: '',
      propertyZip: '',
      stateCode: '',
      previousState: '',
      previousStateCode: '',
      // maritalStatusCode: '',
      suffixCode: '',
      coborrowersuffixCode: '',
      propertyStateCode: '',
      previousZip: '',
      PreviousCityName: '',
      xp: [],
      tu: [],
      eq: [],
      months: constant.months,
      userInfo: {},
      state: '',
      customerCode: '',
      zip: '',
      previousLengthofStayInMonths: '',
      lengthofStayInMonths: '',
      maxbirtdate: '',
      xpReportSelected: false,
      xpScoreSelected: false,
      xpFraudSelected: false,
      tuReportSelected: false,
      tuScoreSelected: false,
      tuFraudSelected: false,
      eqReportSelected: false,
      eqScoreSelected: false,
      lengthofStayInYears: '',
      previousLengthofStayInYears: '',
      loanTypeDescription: '',
      numberofDependencies: '',
      signedFileName: '',
      loanType: '',
      loanTypeCode: '',
      showSpinner: false,
      coborrower: false,
      coborrowerData: '',
      previousAddress: false,
      previousAddressData: {},
      subjectProperty: false,
      alertMessage: '',
      maritalStatus: '',
      coborrowerLastNameSSN: '',
      coborrowerEmail: '',
      coborrowerDOB: '',
      showBureauError: false,
      fileData: '',
      fileType: '',
      isDateValid: true,
      propertyAddressSelected: false,
      fileName: '',
      customers: [],
      authorizedFileItems: [{ file_name: 'dssdsdsd', file_actions: '' }],
      authorizedTableFields: [
        { key: 'file_name', label: 'File Name' },
        { key: 'file_actions', label: 'Actions' },
      ],
      cras: [
        {
          title: 'XP',
          report: 'xpr',
          score: 'xps',
          fraud: 'xpf',
        },
        {
          title: 'TU',
          report: 'tur',
          score: 'tus',
          fraud: 'tuf',
        },
        {
          title: 'EQ',
          report: 'eqr',
          score: 'eqs',
          fraud: 'eqf',
        },
      ],
      craTableHeaders: [
        { key: 'title', label: '', sortable: false },
        { key: 'report', label: 'Report', sortable: false },
        { key: 'score', label: 'Score', sortable: false },
        { key: 'fraud', label: 'Fraud', sortable: false },
      ],
      customerUsers: [],
      breadcrumbs: [
        {
          text: 'Home',
          to: { path: '/home' },
        },
        {
          text: 'Services',
          to: { path: '/home' },
        },
        {
          text: 'Business Credit',
          to: { path: '/home' },
        },
        {
          text: 'Order Report',
          active: true,
        },
      ],
      disableXP: false,
      disableTU: false,
      disableEQ: false,
      disableCoBorrowerInputs: false,
      showPropertyInfoError: false,
    }
  },
  computed: {
    placeholders() {
      return {
        startdate: 'MM/DD/YYYY',
        referenceNumber: 'Reference Number',
        firstName: 'First Name',
        middleName: 'Middle Name',
        lastName: 'Last Name',
        lengthofStayInYears: 'Length of Stay',
        phoneNumber: '(xxx) xxx-xxxx',
        email: 'Email ID',
        coborrowerEmail: 'Email ID',
        ssn: 'xxx-xx-xxxx',
        streetAddress: 'Street Address',
        PreviousStreetAddress: 'Street Address',
        cityName: 'City Name',
        zip: 'xxxxx-xxxx',
        taxID: 'Tax ID',
        numberofDependencies: 'Number of Dependents',
        lengthofStayInMonths: 'Select',
      }
    },

    streetAddressBool() {
      if (!this.streetAddress) return true
      return false
    },

    states() {
      return this.$_allStates
    },

    loanTypes() {
      return this.$_CCRLoanTypes
    },

    maritalStatusList() {
      return this.$_maritalStatuses
    },

    suffixes() {
      return this.$_suffixes
    },

    isAddBureauFlow() {
      return this.$store.getters['orderReport/selectedOrderType'] === 2
    },

    isAddCoBorrowerFlow() {
      return this.$store.getters['orderReport/selectedOrderType'] === 4
    },

    disableInputs() {
      return this.isAddBureauFlow || this.isAddCoBorrowerFlow
    },

    disableOrderBtn() {
      if (this.isAddCoBorrowerFlow) {
        if (
          this.coborrowerFirstName !== '' &&
          this.coborrowerLastName !== '' &&
          this.coborrowerLastNameSSN !== ''
        )
          return false
        return true
      }
      if (this.coborrower) {
        if (this.coborrowerLastNameSSN === this.ssn) {
          return true
        }
      }
      if (this.showPropertyInfoError) {
        return true
      }
      return false
    },
    disableSaveBtn() {
      if (this.showPropertyInfoError) return true
      return false
    },

    isNewOrderFromSummary() {
      return this.$store.getters['orderReport/isNewOrder']
    },
  },

  mounted() {
    this.getCustomer()
    this.getMaxDateLimit()
    this.userInfo = this.$store.state.auth.currentUser.userInfo

    if (
      this.isAddBureauFlow ||
      this.isAddCoBorrowerFlow ||
      this.isNewOrderFromSummary
    ) {
      this.referenceNumber = this.orderData.customerReferenceNumber
      this.loanType =
        this.orderData.loanType === ''
          ? this.orderData.loanType
          : this.loanTypes.find(
              (type) => type.loanTypeCode === this.orderData.loanType
            ).value

      this.firstName = this.orderData.borrower[0].firstName
      this.middleName = this.orderData.borrower[0].middleName
      this.lastName = this.orderData.borrower[0].lastName
      this.suffix =
        this.orderData.borrower[0].suffix === 0
          ? ''
          : this.orderData.borrower[0].suffix
      this.ssn = this.orderData.borrower[0].ssn
      if (this.orderData.borrower[0].dateofBirth !== null) {
        if (this.orderData.borrower[0].dateofBirth.includes('/')) {
          this.startdate = this.orderData.borrower[0].dateofBirth
        } else {
          const dob = this.orderData.borrower[0].dateofBirth
            .slice(0, 10)
            .split('-')
          this.startdate = `${dob[1]}/${dob[2]}/${dob[0]}`
        }
      } else {
        this.startdate = ''
      }

      this.phoneNumber = this.orderData.borrower[0].phone
        .replace(/[^0-9]/g, '')
        .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
      this.email = this.orderData.borrower[0].email
      this.maritalStatus =
        this.orderData.borrower[0].maritalStatus === 0
          ? ''
          : this.orderData.borrower[0].maritalStatus
      this.numberofDependencies = this.orderData.borrower[0].numberOfDependents
      this.streetAddress = this.orderData.borrowerAddresses[0].addressLine1
      this.cityName = this.orderData.borrowerAddresses[0].city
      this.state = this.orderData.borrowerAddresses[0].state
      this.zip = this.orderData.borrowerAddresses[0].zip
      this.lengthofStayInYears = this.orderData.borrowerAddresses[0].lengthOfStayInYears
      // this.lengthofStayInMonths = this.orderData.borrowerAddresses[0]

      const previousAddress = this.orderData.borrowerAddresses.filter(
        (address) => address.type === 2
      )
      this.previousAddress = previousAddress.length > 0
      if (previousAddress.length) {
        this.PreviousStreetAddress = previousAddress[0].addressLine1
        this.PreviousCityName = previousAddress[0].city
        this.previousState = previousAddress[0].state
        this.previousZip = previousAddress[0].zip
        this.previousLengthofStayInYears =
          previousAddress[0].lengthOfStayInYears
        // this.previousLengthofStayInMonths = previousAddress[0].
      }

      if (this.orderData.borrower.length > 1) {
        this.coborrower = this.orderData.borrower.length > 1
        this.coborrowerFirstName = this.orderData.borrower[1].firstName
        this.coborrowerMiddleName = this.orderData.borrower[1].middleName
        this.coborrowerLastName = this.orderData.borrower[1].lastName
        this.coborrowerSuffix =
          this.orderData.borrower[1].suffix === 0
            ? ''
            : this.orderData.borrower[1].suffix
        this.coborrowerLastNameSSN = this.orderData.borrower[1].ssn
        if (this.orderData.borrower[1].dateofBirth === null) {
          this.coborrowerStartdate = ''
        } else {
          if (this.orderData.borrower[1].dateofBirth.includes('/')) {
            this.coborrowerStartdate = this.orderData.borrower[1].dateofBirth
          } else {
            const dob = this.orderData.borrower[1].dateofBirth
              .slice(0, 10)
              .split('-')
            this.coborrowerStartdate = `${dob[1]}/${dob[2]}/${dob[0]}`
          }
        }
        this.coborrowerPhoneNumber = this.orderData.borrower[1].phone
        this.coborrowerEmail = this.orderData.borrower[1].email
      }

      this.subjectProperty =
        this.orderData.subjectPropertyAddress.addressLine1 !== null &&
        this.orderData.subjectPropertyAddress.city !== null &&
        this.orderData.subjectPropertyAddress.state !== null &&
        this.orderData.subjectPropertyAddress.zip !== null
      this.propertyStreetAddress = this.orderData.subjectPropertyAddress.addressLine1
      this.propertyCityName = this.orderData.subjectPropertyAddress.city
      this.propertyState =
        this.orderData.subjectPropertyAddress.state === null
          ? ''
          : this.$_allStates.find(
              (st) =>
                st.stateCode === this.orderData.subjectPropertyAddress.state
            ).value
      this.propertyZip = this.orderData.subjectPropertyAddress.zip

      // this.data.value = this.orderData. //Check again
      this.orderData.bereaus.forEach((bereau) => {
        switch (bereau.name) {
          case 'EF':
            if (bereau.report) {
              this.eqReportSelected = true
              this.eq.push('eqr')
            }
            if (bereau.score) {
              this.eqScoreSelected = true
              this.eq.push('eqs')
            }
            break
          case 'TU':
            if (bereau.report) {
              this.tuReportSelected = true
              this.tu.push('tur')
            }
            if (bereau.score) {
              this.tuScoreSelected = true
              this.tu.push('tus')
            }
            if (bereau.fraud) {
              this.tuFraudSelected = true
              this.tu.push('tuf')
            }
            break
          case 'XP':
            if (bereau.report) {
              this.xpReportSelected = true
              this.xp.push('xpr')
            }
            if (bereau.score) {
              this.xpScoreSelected = true
              this.xp.push('xps')
            }
            if (bereau.fraud) {
              this.xpFraudSelected = true
              this.xp.push('xpf')
            }
            break
        }
      })
    }

    this.CRAconfigurationSetup()

    if (this.isAddBureauFlow) {
      this.disableCoBorrowerInputs = true
    }

    if (this.isAddCoBorrowerFlow) {
      this.coborrower = true
    }

    // Reset orderID and orderType for new order
    if (this.isNewOrderFromSummary)
      this.$store.dispatch('orderReport/setOrderReportFlow')
  },
  destroyed() {
    this.$store.dispatch('orderReport/setOrderReportFlow')
    this.$store.dispatch('orderReport/setFromOrderSummary')
    this.$store.commit('orderReport/SET_IS_NEW_ORDER', false)
  },

  methods: {
    ...userMethods,
    ...orderReportMethods,
    ...toasterMethods,
    async getModal(message, type, method) {
      await this.$refs.msg.showAsync(message, type, 'Ok').then(() => {
        if (method) {
          method()
        }
      })
    },
    // code to display the date in m/d/y format if copy paste of date is done with out slashs
    validateDateFormat(e) {
      let arr = []
      if (e.trim().length === 8 && e[2] !== '/') {
        for (let i = 0; i < e.length; i++) {
          arr[i] = e[i]
        }
        arr.splice(2, 0, '/')
        arr.splice(5, 0, '/')
        this.startdate = arr.toString().replace(/,/g, '')
      }
    },
    validatePropertyAddress() {
      if (
        (this.propertyZip !== '' &&
          this.propertyState !== '' &&
          this.propertyStreetAddress !== '' &&
          this.propertyCityName !== '') ||
        (this.propertyZip === '' &&
          this.propertyState === '' &&
          this.propertyStreetAddress === '' &&
          this.propertyCityName === '')
      ) {
        this.showPropertyInfoError = false
      } else {
        this.showPropertyInfoError = true
      }
    },
    disableInput() {
      this.disabled = !this.disabled
    },
    CRAconfigurationSetup() {
      if (!this.isNewOrderFromSummary) {
        if (this.isAddCoBorrowerFlow) {
          this.disableXP = true
          this.disableTU = true
          this.disableEQ = true
        } else if (this.isAddBureauFlow) {
          this.orderData.bereaus.forEach((bureau) => {
            switch (bureau.name) {
              case 'XP':
                this.disableXP =
                  this.isAddBureauFlow && Object.values(bureau).includes(true)
                break
              case 'EF':
                this.disableEQ =
                  this.isAddBureauFlow && Object.values(bureau).includes(true)
                break
              case 'TU':
                this.disableTU =
                  this.isAddBureauFlow && Object.values(bureau).includes(true)
                break
            }
          })
        }
      }
    },

    toggleEventParent() {
      this.previousAddress = !this.previousAddress
      if (this.previousAddress === true) {
        this.PreviousStreetAddress = this.PreviousStreetAddress
        this.PreviousCityName = this.PreviousCityName
        this.previousState = this.previousState
        this.previousZip = this.previousZip
      } else {
        this.PreviousStreetAddress = ''
        this.PreviousCityName = ''
        this.previousState = ''
        this.previousZip = ''
      }
    },
    getMaxDateLimit() {
      let today = new Date()
      let month =
        today.getMonth() + 1 <= 9
          ? '0' + (today.getMonth() + 1)
          : today.getMonth() + 1

      this.maxbirtdate = `${month}/${today.getDate()}/${today.getFullYear()}`
    },
    orderConsumerCreditReport() {
      let ValidateReportError = false
      if (
        (this.xpFraudSelected || this.xpScoreSelected) &&
        !this.xpReportSelected
      )
        ValidateReportError = true
      if (
        (this.tuFraudSelected || this.tuScoreSelected) &&
        !this.tuReportSelected
      )
        ValidateReportError = true
      if (this.eqScoreSelected && !this.eqReportSelected)
        ValidateReportError = true
      if (ValidateReportError === true) {
        this.getModal('Report must be selected', 'Alert')
      } else {
        this.getStateCode()
        this.getPreviousStateCode()
        this.getPropertyStateCode()
        this.getLoanTypeCode()
        // TODO: Check later
        // this.getMaritalStatusCode()
        this.getOptionSuffixCode()
        if (this.productId === '22') {
          this.OrderReport()
          // Call javascript function to place order for CCR via MCL
        } else {
          this.getOptionCoBorrowerSuffixCode()
          this.searchOrderCCRReports()
        }
      }
    },

    getStateCode() {
      if ((this.state !== '') & (this.state !== null)) {
        this.stateCode = this.states.find(
          (x) => x.value === Number(this.state)
        ).stateCode
      }
    },
    getPreviousStateCode() {
      if (this.previousState !== '' && this.previousState !== null) {
        this.previousStateCode = this.states.find(
          (x) => x.value === Number(this.previousState)
        ).stateCode
      }
    },
    getPropertyStateCode() {
      // TODO: Check later
      if (this.propertyState !== '' && this.propertyState !== null) {
        this.propertyStateCode = this.states.find(
          (x) => x.value === Number(this.propertyState)
        ).stateCode
      }
    },
    getLoanTypeCode() {
      if (this.loanType !== '' && this.loanType !== null) {
        this.loanTypeCode = this.loanTypes.find(
          (x) => x.value === Number(this.loanType)
        ).loanTypeCode
      }
    },
    getOptionSuffixCode() {
      if (this.suffix !== '' && this.suffix !== null && this.suffix !== 0) {
        this.suffixCode = this.suffixes.find(
          (x) => x.value.toString() === this.suffix.toString()
        ).text
      }
    },
    getOptionCoBorrowerSuffixCode() {
      if (
        this.coborrowerSuffix !== '' &&
        this.coborrowerSuffix !== null &&
        this.coborrowerSuffix !== 0
      ) {
        this.coborrowersuffixCode = this.suffixes.find(
          (x) => x.value.toString() === this.coborrowerSuffix.toString()
        ).text
      }
    },

    fetchSelectedCRAs() {
      if (this.xpReportSelected !== false) {
        this.getCras.push({
          Id: 2,
          Name: 'EX',
          report: this.xpReportSelected,
          score: this.xpScoreSelected,
          fraud: this.xpFraudSelected,
        })
      }
      if (this.eqReportSelected !== false) {
        this.getCras.push({
          Id: 1,
          Name: 'EQ',
          report: this.eqReportSelected,
          score: this.eqScoreSelected,
          fraud: null,
        })
      }
      if (this.tuReportSelected !== false) {
        this.getCras.push({
          Id: 3,
          Name: 'TU',
          report: this.tuReportSelected,
          score: this.tuScoreSelected,
          fraud: this.tuFraudSelected,
        })
      }
    },

    getFileData() {
      if (this.fileType === 'application/pdf') {
        this.fileType = this.fileType.substring(this.fileType.length - 3)
        this.fileData = this.fileData.replace(
          'data:application/pdf;base64,',
          ''
        )
      }
      if (this.fileType === 'image/tiff') {
        this.fileType = this.fileType.substring(this.fileType.length - 4)
        this.fileData = this.fileData.replace('data:image/tiff;base64,', '')
      }

      if (this.fileType === 'image/tif') {
        this.fileType = this.fileType.substring(this.fileType.length - 4)
        this.fileData = this.fileData.replace('data:image/tif;base64,', '')
      }
    },

    buildJsonBCRCCRData() {
      this.getFileData()
      this.getLoanTypeCode()
      var ccr = this
      if (ccr.previousAddress) {
        ccr.previousAddressData = JSON.stringify({
          AddressType: constant.priorAddress,
          Street: ccr.PreviousStreetAddress,
          City: ccr.PreviousCityName,
          StateId: ccr.previousState,
          StateCode: ccr.previousStateCode,
          Zip: ccr.previousZip,
          NumberOfYears:
            ccr.previousLengthofStayInYears !== null
              ? Number(ccr.previousLengthofStayInYears)
              : null,
          NumberOfMonths:
            ccr.previousLengthofStayInMonths !== null
              ? Number(ccr.previousLengthofStayInMonths)
              : null,
        })
      }
      if (ccr.coborrower) {
        ccr.coborrowerData = JSON.stringify({
          FirstName: ccr.coborrowerFirstName,
          MiddleName:
            ccr.coborrowerMiddleName !== '' ? ccr.coborrowerMiddleName : '',
          LastName: ccr.coborrowerLastName,
          BorrowerType: 1,
          SSN: ccr.coborrowerLastNameSSN,
          DateOfBirth:
            ccr.coborrowerStartdate !== '' ? ccr.coborrowerStartdate : null,
          MartialStatus: null,
          Suffix: Number(ccr.coborrowerSuffix),
          Address: null,
          PreviousAddress: null,
          Contacts: {
            PhoneNumber: ccr.coborrowerPhoneNumber,
            PhoneType: 0,
          },
          NumberOfDependents: null,
          Email: ccr.coborrowerEmail ? ccr.coborrowerEmail : '',
        })
      }

      return (this.trimergeJsonData = JSON.stringify({
        LoanType: Number(ccr.loanType),
        LoanTypeDescription: ccr.loanTypeCode,
        Borrower: {
          FirstName: ccr.firstName,
          MiddleName: ccr.middleName !== '' ? ccr.middleName : '',
          LastName: ccr.lastName,
          BorrowerType: 0,
          SSN: ccr.ssn,
          DateOfBirth: ccr.startdate !== '' ? ccr.startdate : null,
          MartialStatus:
            ccr.maritalStatus !== '' ? Number(ccr.maritalStatus) : '',
          Suffix: ccr.suffix !== '' ? Number(ccr.suffix) : '',
          Address: {
            AddressType: constant.currentAddress,
            Street: ccr.streetAddress,
            City: ccr.cityName,
            StateId: Number(ccr.state),
            StateCode: ccr.stateCode,
            Zip: ccr.zip,
            NumberOfYears:
              ccr.lengthofStayInYears !== null
                ? Number(ccr.lengthofStayInYears)
                : null,
            NumberOfMonths:
              ccr.lengthofStayInMonths !== null
                ? Number(ccr.lengthofStayInMonths)
                : null,
          },
          PreviousAddress:
            ccr.previousAddressData.length !== 0 &&
            ccr.previousAddressData.length !== undefined
              ? JSON.parse(ccr.previousAddressData)
              : null,
          Contacts: {
            PhoneNumber: ccr.phoneNumber,
            PhoneType: 0,
          },
          NumberOfDependents:
            ccr.numberofDependencies !== ''
              ? Number(ccr.numberofDependencies)
              : null,
          Email: ccr.email,
        },
        CoBorrower:
          ccr.coborrowerData.length !== 0 &&
          ccr.coborrowerData.length !== undefined
            ? JSON.parse(ccr.coborrowerData)
            : null,
        SubjectPropertyAddress: {
          AddressType: '3',
          Street:
            ccr.propertyStreetAddress !== null ? ccr.propertyStreetAddress : '',
          City: ccr.propertyCityName !== null ? ccr.propertyCityName : '',
          StateId: ccr.propertyState !== '' ? ccr.propertyState : '',
          StateCode: ccr.propertyStateCode !== '' ? ccr.propertyStateCode : '',
          Zip: ccr.propertyZip !== '' ? ccr.propertyZip : '',
          NumberOfYears: null,
        },
        AuthorizationFormName:
          ccr.fileName !== undefined &&
          ccr.fileName !== null &&
          ccr.fileName !== ''
            ? ccr.fileName
            : null,
        AuthorizationFormFileType: this.fileType !== '' ? this.fileType : null,
        AuthorizationForm:
          ccr.fileData !== null &&
          ccr.fileData !== undefined &&
          ccr.fileData !== ''
            ? ccr.fileData
            : null,
        CRAs: this.getCras,
        UserId: ccr.userInfo.userId,
        OrderForCustomer: ccr.customerId,
        OrderForUser: ccr.customerUserId,
        ProductId: ccr.productId,
        ReferenceNumber: ccr.referenceNumber,
      }).replace(/^"(.*)"$/, '$1'))
    },
    checkBureauStatus() {
      if (
        this.xp.length === 0 &&
        this.tu.length === 0 &&
        this.eq.length === 0
      ) {
        this.showBureauError = true
      } else {
        this.showBureauError = false
      }
    },

    isValiddateBirth() {
      if (this.startdate !== '' || this.coborrowerStartdate !== '') {
        if (
          this.startdate !== '' &&
          new Date().toJSON().slice(0, 10) < this.startdate
        ) {
          this.getModal('Please enter a valid date of birth', 'Alert')
          return false
        }
        if (
          this.coborrowerStartdate !== '' &&
          new Date().toJSON().slice(0, 10) < this.coborrowerStartdate
        ) {
          this.getModal('Please enter a valid date of birth', 'Alert')
          return false
        }
      }
      return true
    },

    bcrCCRSaveAsDraft() {
      this.getStateCode()
      this.getPreviousStateCode()
      this.getPropertyStateCode()
      this.getLoanTypeCode()
      // TODO: Check later
      // this.getMaritalStatusCode()
      this.getOptionSuffixCode()
      this.checkBureauStatus()
      var isDateValid = this.isValiddateBirth()
      var that = this
      this.$parent.$parent.$validator.validateAll().then((response) => {
        var parentValidation = response
        that.$validator.validate().then((response) => {
          var childvalidation = response
          if (!that.showBureauError) {
            if (parentValidation && childvalidation && isDateValid) {
              that.showSpinner = true
              that.getCras = []
              that.fetchSelectedCRAs()
              that.bcrCCRJsonData = that.buildJsonBCRCCRData()
              return that
                .fetchSaveAsDraftMethod({
                  ccrDraftRequest: that.bcrCCRJsonData,
                })
                .then((response) => {
                  if (response !== undefined && response.data !== undefined) {
                    that.$router.push({
                      name: 'orderSummaryCCRMCL',
                      params: { orderResponse: response.data },
                    })
                  } else {
                    this.setAlert({
                      title: constant.imageHeaderError,
                      msg: constant.errorMessage,
                      variant: constant.errorMessagetype,
                    })
                  }
                })
                .catch((error) => {
                  that.authError = error
                  this.setAlert({
                    title: constant.imageHeaderError,
                    msg: constant.errorMessage,
                    variant: constant.errorMessagetype,
                  })
                })
                .finally(() => {
                  this.showSpinner = false
                })
            }
          }
        })
      })
    },

    OrderReport() {
      var isDateValid = this.isValiddateBirth()
      var that = this
      this.$parent.$parent.$validator.validateAll().then((response) => {
        var parentValidation = response
        this.checkBureauStatus()
        that.$validator.validate().then((response) => {
          this.showSpinner = true
          var childvalidation = response
          if (!that.showBureauError) {
            if (parentValidation && childvalidation && isDateValid) {
              that.showSpinner = true
              that.getCras = []
              that.fetchSelectedCRAs()
              that.buildJsonBCRCCRData()
              return that
                .fetchBCRCCROrderReport({
                  bcrCCRJsonData: that.trimergeJsonData,
                })

                .then((response) => {
                  if (response !== undefined && response.data !== undefined) {
                    if (response.data.responseStatus === 1) {
                      that.$router.push({
                        name: 'orderSummaryCCRMCL',
                        params: { orderResponse: response.data },
                      })
                    } else if (response.data.responseStatus === 0) {
                      // that.showSpinner = false
                      if (response.data.message === null) {
                        this.setAlert({
                          title: constant.imageHeaderError,
                          msg: constant.errorMessage,
                          variant: constant.errorMessagetype,
                        })
                      } else {
                        // this.getModal(response.data.message, 'Message')
                        this.setAlert({
                          title: constant.imageHeaderError,
                          msg: response.data.message,
                          variant: constant.errorMessagetype,
                        })
                      }
                    }
                  } else {
                    // that.showSpinner = false
                    this.setAlert({
                      title: constant.imageHeaderError,
                      msg: constant.errorMessage,
                      variant: constant.errorMessagetype,
                    })
                  }
                })
                .catch((error) => {
                  this.setAlert({
                    title: constant.imageHeaderError,
                    msg: constant.errorMessage,
                    variant: constant.errorMessagetype,
                  })
                  that.authError = error
                })
                .finally(() => {
                  this.showSpinner = false
                })
            }
          }
        })
      })
    },

    // Function to order CCR report from CPSS in house API -- pls do not modify
    searchOrderCCRReports() {
      // var isDateValid = this.isValiddateBirth()
      var that = this
      this.$parent.$parent.$validator.validateAll().then((response) => {
        this.currentUserId = this.$store.state.auth.currentUser.userInfo.userId
        var parentValidation = response
        this.checkBureauStatus()
        that.$validator.validate().then((response) => {
          var childvalidation = response
          if (!that.showBureauError) {
            if (parentValidation && childvalidation) {
              that.showSpinner = true
              var builtBorrowerObject
              var buildCoBorrowerObject
              if (
                this.customerId !== '' &&
                this.customerId !== undefined &&
                this.customers.length > 0
              ) {
                this.customerCode = this.customers.find(
                  (x) => x.value.toString() === this.customerId.toString()
                ).customerCode
              } else if (this.customers.length === 0) {
                this.customerCode = this.userInfo.customerName
              }

              if (
                this.customerUserId !== '' &&
                this.customerUserId !== undefined &&
                this.customerUserCodeArray.length > 0
              ) {
                this.customerUserCode = this.customerUserCodeArray.find(
                  (x) => x.value.toString() === this.customerUserId.toString()
                ).customerUserCode
              } else if (this.customerUserCodeArray.length === 0) {
                this.customerUserCode =
                  this.userInfo.firstName + ' ' + this.userInfo.lastName
              }
              if (that.PreviousStreetAddress !== '') {
                builtBorrowerObject = {
                  AddressLine1: that.PreviousStreetAddress.replace(
                    /\t\s\s+/g,
                    ' '
                  ),
                  City: that.PreviousCityName,
                  State: Number(that.previousState),
                  StateCode: that.previousStateCode,
                  Zip: that.previousZip,
                  LengthOfStayInYears: that.previousLengthofStayInYears,
                  Type: '2',
                }
              }
              if (that.coborrower) {
                buildCoBorrowerObject = {
                  BorrowerIndex: '2',
                  FirstName: that.coborrowerFirstName.replace(/\s\s+/g, '-'),
                  LastName: that.coborrowerLastName.replace(/\s\s+/g, '-'),
                  MiddleName: that.coborrowerMiddleName,
                  Email: that.coborrowerEmail,
                  DateofBirth: that.coborrowerStartdate,
                  SSN: that.coborrowerLastNameSSN.replace(
                    /[`~!@#$%^&*()_|+\-=?;:'",./\s/]/gi,
                    ''
                  ),
                  Phone: that.coborrowerPhoneNumber.replace(
                    /[`~!@#$%^&*()_|+\-=?;:'",./\s/]/gi,
                    ''
                  ),
                  Suffix: Number(that.coborrowerSuffix),
                  SuffixCode: that.coborrowersuffixCode,
                }
              }
              var requestString = {
                Source: 'CPSS UI',
                SourceIp: '',
                OrderType: this.orderType,
                Orderid: this.orderID,
                ForCustomerID: that.customerId,
                ForUserID: that.customerUserId,
                ByCustomerID: that.customerId,
                ByUserID: that.currentUserId,
                ProductId: that.productId,
                UserName: that.customerUserCode,
                CustomerName: that.customerCode, // 'Credit Plus',
                PermissiblePurposeCode: '57',
                CustomerReferenceNumber: that.referenceNumber,
                loanType: that.loanTypeCode,
                Borrower: [
                  {
                    BorrowerIndex: '1',
                    LastName: that.lastName.replace(/\s\s+/g, '-'),
                    MiddleName: that.middleName,
                    Phone: that.phoneNumber.replace(
                      /[`~!@#$%^&*()_|+\-=?;:'",./\s/]/gi,
                      ''
                    ),
                    FirstName: that.firstName.replace(/\s\s+/g, '-'),
                    Suffix: Number(that.suffix),
                    suffixCode: that.suffixCode,
                    SSN: that.ssn.replace(
                      /[`~!@#$%^&*()_|+\-=?;:'",./\s/]/gi,
                      ''
                    ),
                    DateofBirth: that.startdate.toString('yyyy-MM-dd'),
                    MaritalStatus: Number(that.maritalStatus),
                    Numberofdependents:
                      that.numberofDependencies !== ''
                        ? that.numberofDependencies
                        : 0,
                    Email: that.email,
                  },
                  buildCoBorrowerObject,
                ],
                BorrowerAddresses: [
                  {
                    AddressLine1: that.streetAddress.replace(/\t\s\s+/g, ' '),
                    City: that.cityName,
                    State: Number(that.state),
                    StateCode: that.stateCode,
                    Zip: that.zip,
                    Type: 1,
                    LengthOfStayInYears: that.lengthofStayInYears,
                  },
                  builtBorrowerObject,
                ],
                subjectPropertyAddress: {
                  AddressLine1:
                    that.propertyStreetAddress === null
                      ? ''
                      : that.propertyStreetAddress.replace(/\t\s\s+/g, ' '),
                  // TODO: Check later
                  // .replace(
                  //   /\s\s+/g,
                  //   ' '
                  // ),
                  City: that.propertyCityName,
                  State: that.propertyStateCode,
                  Zip: that.propertyZip,
                  // LengthOfStayInYears: that.prev
                },

                Bereaus: [
                  {
                    Name: 'EF',
                    report: that.eqReportSelected,
                    score: that.eqScoreSelected,
                    fraud: false,
                  },
                  {
                    Name: 'XP',
                    report: that.xpReportSelected,
                    score: that.xpScoreSelected,
                    fraud: that.xpFraudSelected,
                  },
                  {
                    Name: 'TU',
                    report: that.tuReportSelected,
                    score: that.tuScoreSelected,
                    fraud: that.tuFraudSelected,
                  },
                ],
              }

              if (this.isAddBureauFlow) {
                if (this.disableEQ) {
                  const EF = requestString.Bereaus[0]
                  EF.fraud = false
                  EF.report = false
                  EF.score = false
                }
                if (this.disableXP) {
                  const XP = requestString.Bereaus[1]
                  XP.fraud = false
                  XP.report = false
                  XP.score = false
                }
                if (this.disableTU) {
                  const TU = requestString.Bereaus[2]
                  TU.fraud = false
                  TU.report = false
                  TU.score = false
                }
              }
              let validateBureauError = false

              if (this.isAddBureauFlow) {
                if (
                  !requestString.Bereaus[0].report &&
                  !requestString.Bereaus[0].score &&
                  !requestString.Bereaus[0].fraud &&
                  !requestString.Bereaus[1].report &&
                  !requestString.Bereaus[1].score &&
                  !requestString.Bereaus[1].fraud &&
                  !requestString.Bereaus[2].report &&
                  !requestString.Bereaus[2].score &&
                  !requestString.Bereaus[2].fraud
                ) {
                  validateBureauError = true
                }
              }

              JSON.stringify(requestString).replace(/^"(.*)"$/, '$1')
              if (!validateBureauError) {
                return this.fetchOrderCCRReport({
                  requestString,
                }).then((response) => {
                  if (response.request.status !== 200) {
                    if (
                      response.response.data.message !== '' &&
                      response.response.data.message !== null &&
                      response.response.data.message !== undefined
                    ) {
                      // this.getModal(response.response.data.message, 'Message')
                      this.setAlert({
                        title: constant.imageHeaderError,
                        msg: response.response.data.message,
                        variant: constant.errorMessagetype,
                      })
                    } else if (
                      response.request.response !== null &&
                      response.request.response !== undefined
                    ) {
                      // this.getModal(response.request.response, 'Message')
                      this.setAlert({
                        title: constant.imageHeaderError,
                        msg: response.request.response,
                        variant: constant.errorMessagetype,
                      })
                    }
                    this.showSpinner = false
                  } else if (response.request.status === 200) {
                    localStorage.setItem(
                      'ccrFlag',
                      JSON.stringify({
                        flag: 'true',
                        id: response.data.orderId,
                      })
                    )

                    this.$router.push({
                      name: 'ccrOrderSummary',
                      params: {
                        orderId: response.data.orderId,
                      },
                    })
                  }

                  this.showSpinner = false
                })
              } else {
                this.getModal(
                  'Order cannot be completed as no new Bureaus are selected',
                  'Message'
                )
                this.showSpinner = false
                return false
              }
            }
          }
        })
      })
    },
    clearFiles(index) {
      this.signedFileName = ''
      this.fileData = ''
      this.fileType = ''
      this.fileName = ''
      this.signedfile = null
      this.isDisabled = false
    },
    ConvertToBase64(pdf) {
      var fileReader = new FileReader()
      this.fileName = pdf.name
      var current = this
      fileReader.readAsDataURL(pdf)
      fileReader.onload = function(event) {
        current.fileData = event.target.result
        current.showSpinner = false
      }
    },

    onChangePdf(e) {
      this.showSpinner = true
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        this.getModal(constant.emptyPdf, 'Message')
        return
      }

      if (
        files[0].type !== 'application/pdf' &&
        files[0].type !== 'image/tiff' &&
        files[0].type !== 'image/tif'
      ) {
        this.getModal(files[0].type + ' - Invalid file type.', 'Message')
        return
      }

      if (files[0].size > 1377911) {
        this.getModal(constant.PdfSize, 'Message')
        this.isDisabled = false
        this.signedFileName = ''
        return
      }
      this.signedFileName = this.signedfile.name
      this.authorizedFileItems[0].file_name = this.signedFileName
      this.fileType = files[0].type
      this.ConvertToBase64(files[0])
      this.isDisabled = true
    },

    f(pdf) {
      this.fileItemsTable.push({ file_name: pdf.name })
      this.$refs.modaldoc.style.display = 'none'
    },

    getCustomer() {
      this.customerUser = ''
      this.chooseProduct = ''
      return this.fetchCustomer({
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      })
        .then((response) => {
          let i = 0
          for (i = 0; i < response.data.customers.length; i++) {
            let eachCustomer = response.data.customers[i]
            if (eachCustomer.isActive === true) {
              this.customers.push({
                text: eachCustomer.customerAccNumber + '-' + eachCustomer.name,
                value: eachCustomer.customerId,
                customerCode: eachCustomer.name,
              })
            }
          }
        })
        .catch((error) => {
          this.authError = error
          this.setAlert({
            title: constant.imageHeaderError,
            msg: constant.errorMessage,
            variant: constant.errorMessagetype,
          })
        })
        .finally(() => {
          this.showSpinner = false
        })
    },

    toggleEventParent2: function() {
      this.coborrower = !this.coborrower
      if (this.coborrower === true) {
        this.coborrowerFirstName = this.coborrowerFirstName
        this.coborrowerMiddleName = this.coborrowerMiddleName
        this.coborrowerLastName = this.coborrowerLastName
        this.coborrowerSuffix = this.coborrowerSuffix
        this.coborrowerLastNameSSN = this.coborrowerLastNameSSN
        this.coborrowerStartdate = this.coborrowerStartdate
        this.coborrowerPhoneNumber = this.coborrowerPhoneNumber
        this.coborrowerEmail = this.coborrowerEmail
      } else {
        this.coborrowerFirstName = ''
        this.coborrowerMiddleName = ''
        this.coborrowerLastName = ''
        this.coborrowerSuffix = ''
        this.coborrowerLastNameSSN = ''
        this.coborrowerStartdate = ''
        this.coborrowerPhoneNumber = ''
        this.coborrowerEmail = ''
      }
    },
    toggleEventParent3: function() {
      this.propertyAddressSelected = !this.propertyAddressSelected
      if (this.propertyAddressSelected === true) {
        this.propertyStreetAddress = this.streetAddress
        this.propertyCityName = this.cityName
        this.propertyState = this.state
        this.propertyZip = this.zip
        this.validatePropertyAddress()
        this.disableInput()
      } else {
        this.propertyStreetAddress = ''
        this.propertyCityName = ''
        this.propertyState = ''
        this.propertyZip = ''
      }
    },
    getConsumerCreditReports(event) {
      this.$validator.validate().then((response) => {
        return response
      })
    },

    onChangeScore(targetval) {
      if (targetval === 'xps') {
        this.xpScoreSelected = event.target.checked
        if (!this.xpReportSelected) this.xpReportSelected = true

        if (!this.xp.includes('xpr')) this.xp.push('xpr')
        if (!this.xp.includes('xps')) this.xp.push('xps')

        if (event.target.checked === false) {
          const xpsIndex = this.xp.indexOf('xps')
          this.xp.splice(xpsIndex, 1)
        }
      }

      if (targetval === 'tus') {
        this.tuScoreSelected = event.target.checked
        if (!this.tuReportSelected) this.tuReportSelected = true

        if (!this.tu.includes('tur')) this.tu.push('tur')
        if (!this.tu.includes('tus')) this.tu.push('tus')

        if (event.target.checked === false) {
          const tusIndex = this.tu.indexOf('tus')
          this.tu.splice(tusIndex, 1)
        }
      }

      if (targetval === 'eqs') {
        this.eqScoreSelected = event.target.checked
        if (!this.eqReportSelected) this.eqReportSelected = true

        if (!this.eq.includes('eqr')) this.eq.push('eqr')
        if (!this.eq.includes('eqs')) this.eq.push('eqs')

        if (event.target.checked === false) {
          const eqsIndex = this.eq.indexOf('eqs')
          this.eq.splice(eqsIndex, 1)
        }
      }

      this.showBureauError = false
    },

    onChangeReport(targetval) {
      if (targetval === 'xpr') {
        // this.xpReportSelected = event.target.checked
        if (!this.xp.includes('xpr')) {
          this.xp.push('xpr')
          this.xpReportSelected = true
        } else {
          this.xp.splice(0, 1)
          this.xpReportSelected = false
        }
      }

      if (targetval === 'tur') {
        // this.tuReportSelected = event.target.checked
        if (!this.tu.includes('tur')) {
          this.tu.push('tur')
          this.tuReportSelected = true
        } else {
          this.tu.splice(0, 1)
          this.tuReportSelected = false
        }
      }

      if (targetval === 'eqr') {
        // this.eqReportSelected = event.target.checked
        if (!this.eq.includes('eqr')) {
          this.eq.push('eqr')
          this.eqReportSelected = true
        } else {
          this.eq.splice(0, 1)
          this.eqReportSelected = false
        }
      }

      this.showBureauError = false
    },

    onChangeFraud(targetval) {
      if (targetval === 'xpf') {
        this.xpFraudSelected = event.target.checked
        if (!this.xpReportSelected) this.xpReportSelected = true

        if (!this.xp.includes('xpr')) this.xp.push('xpr')
        if (!this.xp.includes('xpf')) this.xp.push('xpf')

        if (event.target.checked === false) {
          const xpfIndex = this.xp.indexOf('xpf')
          this.xp.splice(xpfIndex, 1)
        }
      }

      if (targetval === 'tuf') {
        this.tuFraudSelected = event.target.checked
        if (!this.tuReportSelected) this.tuReportSelected = true

        if (!this.tu.includes('tur')) this.tu.push('tur')
        if (!this.tu.includes('tuf')) this.tu.push('tuf')

        if (event.target.checked === false) {
          const tufIndex = this.tu.indexOf('tuf')
          this.tu.splice(tufIndex, 1)
        }
      }

      this.showBureauError = false
    },
    formatAddress() {
      this.streetAddress = this.streetAddress.replace(/\s+/g, ' ')
    },
  },
}
</script>

<template>
  <div>
    <BaseSpinner v-if="showSpinner" />
    <BaseModalLayout ref="msg" hide-cancel modal-size="md" />
    <b-form @submit.prevent="orderConsumerCreditReport">
      <b-row class="pb-3">
        <b-col md="3">
          <BaseEInputText
            id="referenceNumber"
            v-model="referenceNumber"
            v-validate="{ required: false, regex: /^[A-Za-z0-9 ]+$/ }"
            validattor="^[A-Za-z0-9]+$"
            type="text"
            name="referenceNumber"
            maxlength="15"
            label-content="Reference Number"
            data-vv-as="Reference No."
            :class="{
              input: true,
              'is-danger': errors.has('referenceNumber'),
            }"
            :placeholder="placeholders.referenceNumber"
            :is-disabled="disableInputs"
          ></BaseEInputText>
          <div class="error">
            {{ errors.first('referenceNumber') }}
          </div>
        </b-col>

        <b-col md="3">
          <BaseELabel label="Loan Type" />
          <BaseDropdown
            v-model="loanType"
            :field-id="loanType"
            :options="loanTypes"
            :is-disabled="disableInputs"
            name="loanType"
          ></BaseDropdown>
        </b-col>
      </b-row>
      <b-row align-v="center">
        <b-col md="auto">
          <div>
            <BaseELabel
              :class="$style.labelSubHeading"
              label="Personal Information"
            />
          </div>
        </b-col>
        <b-col class="border-bottom"></b-col>
      </b-row>

      <b-row class="pb-3 border-bottom">
        <b-col md="3">
          <BaseEInputText
            id="firstName"
            v-model="firstName"
            v-validate="{ required: true, regex: /^[A-Za-z0-9- ]+$/ }"
            validattor="^[A-Za-z0-9- ]+$"
            data-vv-as="First Name"
            type="text"
            name="firstName"
            maxlength="50"
            label-content="First Name"
            mark-required
            :class="{
              input: true,
              'is-danger': errors.has('firstName'),
            }"
            :placeholder="placeholders.firstName"
            :is-disabled="disableInputs"
          ></BaseEInputText>
          <div class="error">
            {{ errors.first('firstName') }}
          </div>
        </b-col>
        <b-col md="3">
          <BaseEInputText
            id="middleName"
            v-model="middleName"
            v-validate="{ required: false, regex: /^[A-Za-z0-9]+$/ }"
            validattor="^[A-Za-z0-9]+$"
            type="text"
            name="middleName"
            maxlength="50"
            label-content="Middle Name"
            data-vv-as="Middle Name"
            :class="{
              input: true,
              'is-danger': errors.has('middleName'),
            }"
            :placeholder="placeholders.middleName"
            :is-disabled="disableInputs"
          ></BaseEInputText>
          <div class="error">
            {{ errors.first('middleName') }}
          </div>
        </b-col>
        <b-col md="3">
          <BaseEInputText
            id="lastName"
            v-model="lastName"
            v-validate="{
              required: true,
              regex: /^[A-Za-z0-9-' ]+$/,
            }"
            validattor="^[A-Za-z0-9-' ]+$"
            data-vv-as="Last Name"
            type="text"
            name="lastName"
            maxlength="50"
            label-content="Last Name"
            mark-required
            :class="{
              input: true,
              'is-danger': errors.has('lastName'),
            }"
            :placeholder="placeholders.lastName"
            :is-disabled="disableInputs"
          ></BaseEInputText>
          <div class="error"> {{ errors.first('lastName') }} </div>
        </b-col>
        <b-col md="3">
          <BaseELabel label="Suffix" />
          <BaseDropdown
            v-model="suffix"
            :field-id="suffix"
            :options="suffixes"
            :is-disabled="disableInputs"
            name="sufix"
          ></BaseDropdown>
        </b-col>

        <b-col md="3">
          <BaseEInputText
            id="ssn"
            v-model="ssn"
            v-validate="{ required: true, regex: /^\d{3}-?\d{2}-?\d{4}$/ }"
            validattor="[0-9]"
            maskker="(\d{3})(\d{2})(\d{4})"
            formatter="$1-$2-$3"
            type="text"
            maxlength="11"
            name="ssn"
            label-content="SSN"
            data-vv-as="SSN"
            mark-required
            :class="{
              input: true,
              'is-danger': errors.has('ssn'),
            }"
            :placeholder="placeholders.ssn"
            :is-disabled="disableInputs"
          ></BaseEInputText>
          <div class="error">
            {{ errors.first('ssn') }}
          </div>
        </b-col>
        <b-col md="3">
          <BaseELabel label="Date of Birth" />
          <BaseDate
            v-model="startdate"
            type="date"
            :field-id="startdate"
            name="startdate"
            data-vv-as="Date of Birth"
            :max="maxbirtdate"
            :class="{
              input: true,
              'is-danger': errors.has('startdate'),
            }"
            :disabled="disableInputs"
            @input="validateDateFormat"
          ></BaseDate>
          <div class="error">
            {{ errors.first('startdate') }}
          </div>
        </b-col>
        <b-col md="3">
          <BaseEInputText
            id="phoneNumber"
            v-model="phoneNumber"
            v-validate="{
              required: false,
              regex: /^\(\d{3}\)\s*\d{3}(?:-|\s*)\d{4}$/,
            }"
            validattor="[0-9]"
            maskker="(\d{3})(\d{3})(\d{4})"
            formatter="($1) $2-$3"
            type="text"
            maxlength="14"
            name="phoneNumber"
            label-content="Phone Number"
            data-vv-as="Phone #"
            :class="{
              input: true,
              'is-danger': errors.has('phoneNumber'),
            }"
            :placeholder="placeholders.phoneNumber"
            :is-disabled="disableInputs"
          ></BaseEInputText>
          <!-- // TODO: Check later -->
          <!--  regex: /^\(\d{3}\)\s*\d{3}(?:-|\s*)\d{4}$/,            -->
          <div class="error">
            {{ errors.first('phoneNumber') }}
          </div>
        </b-col>
        <b-col md="3">
          <BaseEInputText
            id="text-email"
            v-model="email"
            v-validate="'email'"
            maxlength="50"
            type="text"
            name="email"
            label-content="Email ID"
            data-vv-as="Email ID"
            :placeholder="placeholders.email"
            :is-disabled="disableInputs"
          ></BaseEInputText>
          <div class="error">
            {{ errors.first('email') }}
          </div>
        </b-col>
        <b-col md="3">
          <BaseELabel label="Marital Status" />
          <BaseDropdown
            id="marital-status"
            v-model="maritalStatus"
            :options="maritalStatusList"
            :is-disabled="disableInputs"
            class="mb-1"
            name="maritalStatus"
          ></BaseDropdown>
        </b-col>
        <b-col md="3">
          <BaseEInputText
            v-model="numberofDependencies"
            v-validate="{ required: false, regex: /^[0-9 ]+$/ }"
            validattor="^[0-9]+$"
            :field-id="numberofDependencies"
            maxlength="2"
            type="text"
            name="numberofDependencies"
            label-content="Number of Dependents"
            :placeholder="placeholders.numberofDependencies"
            :is-disabled="disableInputs"
          ></BaseEInputText>
        </b-col>
      </b-row>

      <b-row class="pb-3 border-bottom">
        <b-col md="5">
          <BaseEInputText
            id="streetAddress"
            v-model="streetAddress"
            v-validate="{
              required: true,
              regex: /^[A-Za-z0-9-/#٠١٢٣٤٥٦٧٨٩ ]+$/,
            }"
            validattor="^[A-Za-z0-9-/#٠١٢٣٤٥٦٧٨٩ ]+$"
            type="text"
            name="streetAddress"
            maxlength="50"
            label-content="Street"
            data-vv-as="Street Address"
            mark-required
            :class="{
              input: true,
              'is-danger': errors.has('street'),
            }"
            :placeholder="placeholders.streetAddress"
            :is-disabled="disableInputs"
            @input="formatAddress"
          ></BaseEInputText>
          <div v-if="streetAddressBool" class="error">
            {{ errors.first('streetAddress') }}
          </div>
        </b-col>
        <b-col md="3">
          <BaseEInputText
            id="cityName"
            v-model="cityName"
            v-validate="{ required: true, regex: /^[A-Za-z-. ]+$/ }"
            validattor="^[A-Za-z-. ]+$"
            type="text"
            name="cityName"
            maxlength="50"
            label-content="City"
            mark-required
            data-vv-as="City Name"
            :class="{
              input: true,
              'is-danger': errors.has('city'),
            }"
            :placeholder="placeholders.cityName"
            :is-disabled="disableInputs"
          ></BaseEInputText>
          <div class="error">
            {{ errors.first('cityName') }}
          </div>
        </b-col>
        <b-col md="2">
          <BaseELabel mark-required label="State" />
          <BaseDropdown
            v-model="state"
            v-validate="'required'"
            :field-id="state"
            :options="states"
            name="state"
            :placeholder="placeholders.state"
            :is-disabled="disableInputs"
          ></BaseDropdown>
          <div v-show="errors.has('state')" class="error">
            State is required
          </div>
        </b-col>
        <b-col md="2">
          <BaseEInputText
            id="zip"
            v-model="zip"
            v-validate="{ required: true }"
            validattor="[0-9]"
            maskker="(\d{5})(\d{4})"
            formatter="$1-$2"
            type="text"
            maxlength="10"
            name="zip"
            label-content="Zip"
            data-vv-as="Zip"
            mark-required
            :class="{
              input: true,
              'is-danger': errors.has('zip'),
            }"
            :placeholder="placeholders.zip"
            :is-disabled="disableInputs"
          ></BaseEInputText>
          <div class="error"> {{ errors.first('zip') }} </div>
        </b-col>
        <b-col md="3">
          <BaseEInputText
            id="lengthofStayInYears"
            v-model="lengthofStayInYears"
            v-validate="{ required: false, regex: /^[0-9 ]+$/ }"
            validattor="^[0-9]+$"
            maxlength="2"
            type="text"
            label-content="Length of Stay"
            :placeholder="placeholders.lengthofStayInYears"
            :is-disabled="disableInputs"
          ></BaseEInputText>
        </b-col>
        <b-col v-if="productId === '22'" md="3">
          <BaseELabel label="Number of Months" />
          <BaseDropdown
            v-model="lengthofStayInMonths"
            :field-id="lengthofStayInMonths"
            :options="months"
            name="lengthofStayInMonths"
            :placeholder="placeholders.lengthofStayInMonths"
            :is-disabled="disableInputs"
          ></BaseDropdown>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="4">
          <BaseELabel label="Previous Address" />
          <BaseSwitch
            id="previousAddress"
            v-model="previousAddress"
            name="previousAddress"
            class="float-left pt-2"
            checkedlbl="Yes"
            uncheckedlbl="No"
            :is-disabled="disableInputs"
            :is-checked="previousAddress"
            @toggleEvent="toggleEventParent"
          />
        </b-col>
      </b-row>
      <b-row v-if="previousAddress === true" class="pb-3 border-bottom">
        <b-col md="5">
          <BaseEInputText
            id="PreviousStreetAddress"
            v-model="PreviousStreetAddress"
            v-validate="{
              required: true,
              regex: /^[A-Za-z0-9-/#٠١٢٣٤٥٦٧٨٩ ]+$/,
            }"
            validattor="^[A-Za-z0-9-/#٠١٢٣٤٥٦٧٨٩ ]+$"
            type="text"
            name="PreviousStreetAddress"
            data-vv-as="Street Address"
            maxlength="50"
            label-content="Street"
            mark-required
            :class="{
              input: true,
              'is-danger': errors.has('street'),
            }"
            :placeholder="placeholders.PreviousStreetAddress"
            :is-disabled="disableInputs"
          ></BaseEInputText>
          <div class="error">
            {{ errors.first('PreviousStreetAddress') }}
          </div>
        </b-col>
        <b-col md="3">
          <BaseEInputText
            id="PreviousCityName"
            v-model="PreviousCityName"
            v-validate="{ required: true, regex: /^[A-Za-z-. ]+$/ }"
            validattor="^[A-Za-z-. ]+$"
            type="text"
            name="PreviousCityName"
            maxlength="50"
            label-content="City"
            mark-required
            data-vv-as="City Name"
            :class="{
              input: true,
              'is-danger': errors.has('city'),
            }"
            :placeholder="placeholders.cityName"
            :is-disabled="disableInputs"
          ></BaseEInputText>
          <div class="error">
            {{ errors.first('PreviousCityName') }}
          </div>
        </b-col>
        <b-col md="2">
          <BaseELabel mark-required label="State" />
          <BaseDropdown
            v-model="previousState"
            v-validate="'required'"
            :field-id="previousState"
            :options="states"
            name="previousState"
            :placeholder="placeholders.previousState"
            :is-disabled="disableInputs"
          ></BaseDropdown>
          <div v-show="errors.has('previousState')" class="error">
            State is required
          </div>
        </b-col>
        <b-col md="2">
          <BaseEInputText
            id="previousZip"
            v-model="previousZip"
            v-validate="{ required: true }"
            validattor="[0-9]"
            maskker="(\d{5})(\d{4})"
            data-vv-as="Zip"
            formatter="$1-$2"
            type="text"
            maxlength="10"
            name="previousZip"
            label-content="Zip"
            mark-required
            :class="{
              input: true,
              'is-danger': errors.has('zip'),
            }"
            :placeholder="placeholders.zip"
            :is-disabled="disableInputs"
          ></BaseEInputText>
          <!-- // TODO: Check later -->
          <!-- regex: /^[0-9]{5}(?:-[0-9]{4})?$/ -->
          <div class="error"> {{ errors.first('previousZip') }} </div>
        </b-col>
        <b-col md="3">
          <BaseEInputText
            id="previousLengthofStayInYears"
            v-model="previousLengthofStayInYears"
            v-validate="{ required: false, regex: /^[0-9 ]+$/ }"
            validattor="^[0-9]+$"
            maxlength="2"
            type="text"
            label-content="Length of Stay"
            :placeholder="placeholders.lengthofStayInYears"
            :is-disabled="disableInputs"
          ></BaseEInputText>
        </b-col>
        <b-col v-if="productId === '22'" md="3">
          <BaseELabel label="Number of Months" />
          <BaseDropdown
            id="Previous-Number-Of-Months"
            v-model="previousLengthofStayInMonths"
            :options="months"
            :is-disabled="disableInputs"
            name="previousLengthofStayInMonths"
          ></BaseDropdown>
        </b-col>
      </b-row>
      <b-row class="pb-3">
        <b-col md="3">
          <BaseELabel label="Co-Borrower" />
          <BaseSwitch
            id="coborrower"
            v-model="coborrower"
            name="coborrower"
            class="float-left pt-2"
            checkedlbl="Yes"
            uncheckedlbl="No"
            :is-checked="coborrower"
            :is-disabled="disableInputs"
            @toggleEvent="toggleEventParent2"
          />
        </b-col>
      </b-row>
      <b-row v-if="coborrower === true" class="pb-3 border-bottom">
        <b-col md="3">
          <BaseEInputText
            id="coborrowerFirstName"
            v-model="coborrowerFirstName"
            v-validate="{ required: true, regex: /^[A-Za-z0-9- ]+$/ }"
            validattor="^[A-Za-z0-9- ]+$"
            type="text"
            name="coborrowerFirstName"
            maxlength="50"
            label-content="First Name"
            data-vv-as="First Name"
            mark-required
            :class="{
              input: true,
              'is-danger': errors.has('coborrowerFirstName'),
            }"
            :placeholder="placeholders.firstName"
            :is-disabled="disableCoBorrowerInputs"
          ></BaseEInputText>
          <div class="error">
            {{ errors.first('coborrowerFirstName') }}
          </div>
        </b-col>
        <b-col md="3">
          <BaseEInputText
            id="coborrowerMiddleName"
            v-model="coborrowerMiddleName"
            v-validate="{ required: false, regex: /^[A-Za-z0-9]+$/ }"
            validattor="^[A-Za-z0-9]+$"
            type="text"
            name="coborrowerMiddleName"
            maxlength="50"
            label-content="Middle Name"
            data-vv-as="Middle Name"
            :class="{
              input: true,
              'is-danger': errors.has('coborrowerMiddleName'),
            }"
            :placeholder="placeholders.middleName"
            :is-disabled="disableCoBorrowerInputs"
          ></BaseEInputText>
          <div class="error">
            {{ errors.first('coborrowerMiddleName') }}
          </div>
        </b-col>
        <b-col md="3">
          <BaseEInputText
            id="coborrowerLastName"
            v-model="coborrowerLastName"
            v-validate="{ required: true, regex: /^[A-Za-z0-9-' ]+$/ }"
            validattor="^[A-Za-z0-9-' ]+$"
            type="text"
            name="coborrowerLastName"
            maxlength="50"
            label-content="Last Name"
            data-vv-as="Last Name"
            mark-required
            :class="{
              input: true,
              'is-danger': errors.has('coborrowerLastName'),
            }"
            :placeholder="placeholders.lastName"
            :is-disabled="disableCoBorrowerInputs"
          ></BaseEInputText>
          <div class="error">
            {{ errors.first('coborrowerLastName') }}
          </div>
        </b-col>
        <b-col md="3">
          <BaseELabel label="Suffix" />
          <BaseDropdown
            id="coborrowerSuffix"
            v-model="coborrowerSuffix"
            :options="suffixes"
            :is-disabled="disableCoBorrowerInputs"
            name="suffix"
          ></BaseDropdown>
        </b-col>
        <b-col md="3">
          <BaseEInputText
            id="coborrowerLastNameSSN"
            v-model="coborrowerLastNameSSN"
            v-validate="{ required: true, regex: /^\d{3}-?\d{2}-?\d{4}$/ }"
            validattor="[0-9]"
            maskker="(\d{3})(\d{2})(\d{4})"
            formatter="$1-$2-$3"
            maxlength="11"
            type="text"
            name="coborrowerLastNameSSN"
            label-content="SSN"
            data-vv-as="SSN"
            mark-required
            :class="{
              input: true,
              'is-danger': errors.has('coborrowerLastNameSSN'),
            }"
            :placeholder="placeholders.ssn"
            :is-disabled="disableCoBorrowerInputs"
          ></BaseEInputText>
          <div class="error">
            {{ errors.first('coborrowerLastNameSSN') }}
          </div>
          <div v-if="coborrowerLastNameSSN === ssn" class="error">
            Borrower's SSN and Co-Borrower's SSN cannot be Same.
          </div>
        </b-col>
        <b-col md="3">
          <BaseELabel label="Date of Birth" />
          <BaseDate
            v-model="coborrowerStartdate"
            type="date"
            :field-id="'coBorrowerStartdate'"
            name="coBorrowerStartdate"
            :max="maxbirtdate"
            :placeholder="placeholders.startdate"
            :class="{
              input: true,
              'is-danger': errors.has('coBorrowerStartdate'),
            }"
            :disabled="disableCoBorrowerInputs"
          ></BaseDate>
          <div v-show="errors.has('coborrowerStartdate')" class="error"
            >Invalid Date of Birth</div
          >
        </b-col>

        <b-col md="3">
          <BaseEInputText
            id="coborrowerPhoneNumber"
            v-model="coborrowerPhoneNumber"
            v-validate="{
              required: false,
            }"
            validattor="[0-9]"
            maskker="(\d{3})(\d{3})(\d{4})"
            formatter="($1) $2-$3"
            type="text"
            maxlength="14"
            name="coborrowerPhoneNumber"
            data-vv-as="Phone #"
            label-content="Phone Number"
            :class="{
              input: true,
              'is-danger': errors.has('coborrowerPhoneNumber'),
            }"
            :placeholder="placeholders.phoneNumber"
            :is-disabled="disableCoBorrowerInputs"
          ></BaseEInputText>
          <!-- regex: /^\(\d{3}\)\s*\d{3}(?:-|\s*)\d{4}$/, -->
          <div class="error">
            {{ errors.first('coborrowerPhoneNumber') }}
          </div>
        </b-col>
        <b-col md="3">
          <BaseEInputText
            id="coborrowerEmail"
            v-model="coborrowerEmail"
            v-validate="'email'"
            maxlength="50"
            type="text"
            name="coborrowerEmail"
            data-vv-as="Email ID"
            label-content="Email ID"
            :placeholder="placeholders.email"
            :is-disabled="disableCoBorrowerInputs"
          ></BaseEInputText>
          <div class="error">
            {{ errors.first('coborrowerEmail') }}
          </div>
        </b-col>
      </b-row>
      <b-row align-v="center">
        <b-col md="auto">
          <div>
            <BaseELabel
              :class="$style.labelSubHeading"
              label="Subject Property Information"
            />
          </div>
        </b-col>
        <b-col class="border-bottom"></b-col>
      </b-row>
      <b-row class="pt-1 pb-1">
        <div class="col-12">
          <b-col md="4" class="pl-0">
            <BaseELabel
              size="md"
              label="Subject Property Address Same As
            Residential Address"
            />
          </b-col>
        </div>
      </b-row>
      <b-row>
        <b-col>
          <BaseSwitch
            id="subjectProperty"
            v-model="subjectProperty"
            name="subjectProperty"
            checkedlbl="Yes"
            uncheckedlbl="No"
            :is-checked="subjectProperty"
            :is-disabled="disableInputs"
            @toggleEvent="toggleEventParent3"
          />
        </b-col>
      </b-row>
      <b-row class="pb-3">
        <b-col md="5">
          <BaseEInputText
            id="propertyStreetAddress"
            v-model="propertyStreetAddress"
            v-validate="{
              required: false,
              regex: /^[A-Za-z0-9-/#٠١٢٣٤٥٦٧٨٩ ]+$/,
            }"
            validattor="^[A-Za-z0-9-/#٠١٢٣٤٥٦٧٨٩ ]+$"
            type="text"
            name="propertyStreetAddress"
            maxlength="50"
            data-vv-as="Street"
            label-content="Street"
            autocomplete="new-password"
            :class="{
              input: true,
              'is-danger': errors.has('propertyStreetAddress'),
            }"
            :placeholder="placeholders.streetAddress"
            :is-disabled="disableInputs"
            :readonly="disabled"
            @change="validatePropertyAddress"
          ></BaseEInputText>
          <div class="error">
            {{ errors.first('propertyStreetAddress') }}
          </div>
        </b-col>
        <b-col md="3">
          <BaseEInputText
            id="propertyCityName"
            v-model="propertyCityName"
            v-validate="{ required: false, regex: /^[A-Za-z-. ]+$/ }"
            validattor="^[A-Za-z-. ]+$"
            type="text"
            name="propertyCityName"
            maxlength="50"
            label-content="City"
            autocomplete="new-password"
            data-vv-as="City Name"
            :class="{
              input: true,
              'is-danger': errors.has('propertyCityName'),
            }"
            :placeholder="placeholders.cityName"
            :is-disabled="disableInputs"
            :readonly="disabled"
            @change="validatePropertyAddress"
          ></BaseEInputText>
          <div class="error">
            {{ errors.first('propertyCityName') }}
          </div>
        </b-col>
        <b-col md="2">
          <BaseELabel label="State" />
          <BaseDropdown
            v-model="propertyState"
            :field-id="propertyState"
            :options="states"
            :is-disabled="disableInputs || disabled"
            class="mb-1"
            autocomplete="new-password"
            name="propertyState"
            @change="validatePropertyAddress"
          ></BaseDropdown>
          <div v-show="errors.has('propertyState')" class="error">
            State is required
          </div>
        </b-col>
        <b-col md="2">
          <BaseEInputText
            id="propertyZipp"
            v-model="propertyZip"
            v-validate="{ required: false }"
            validattor="[0-9]"
            maskker="(\d{5})(\d{4})"
            formatter="$1-$2"
            type="text"
            maxlength="10"
            autocomplete="new-password"
            name="propertyZip"
            label-content="Zip"
            :placeholder="placeholders.zip"
            :is-disabled="disableInputs"
            :readonly="disabled"
            @change="validatePropertyAddress"
          ></BaseEInputText>
          <div v-show="errors.has('propertyZipp')" class="error">
            Zip is required
          </div>
        </b-col>
        <b-col>
          <div v-show="showPropertyInfoError === true" class="error">
            All the Subject Property Information fields should be filled
          </div>
        </b-col>
      </b-row>
      <b-row v-if="productId === '22'" align-v="center" class="pt-2">
        <b-col md="auto">
          <BaseELabel
            :class="$style.labelSubHeading"
            label="Borrower's Authorization Form"
          />
        </b-col>
        <b-col class="border-bottom"></b-col>
      </b-row>
      <b-row v-if="productId === '22'" class="pb-3">
        <b-col class="text-right my-2">
          <b-button
            id="show-btn"
            :disabled="isDisabled"
            variant="outline-dark"
            @click="showConfirm = true"
            >Upload Document</b-button
          >
        </b-col>
        <!--table for upload document start-->
        <b-col md="12">
          <b-table
            id="tblBorrowerAuthorization"
            class="text-center"
            hover
            striped
            bordered
            responsive="sm"
            :items="authorizedFileItems"
            :fields="authorizedTableFields"
          >
            <template v-slot:cell(file_name)>
              <b class="text-info">{{ signedFileName }} </b>
            </template>
            <template v-slot:cell(file_actions)="data">
              <BaseIcon
                v-model="data.value"
                name="times-circle"
                :class="$style.delActionBtn"
                @click="clearFiles"
              />
            </template>
          </b-table>
        </b-col>
        <!--table for upload document ends-->
      </b-row>
      <b-row align-v="center" class="pt-2">
        <b-col md="auto">
          <div>
            <BaseELabel
              :class="$style.labelSubHeading"
              label="CRA  Configuration"
            />
          </div>
        </b-col>
        <b-col class="border-bottom"></b-col>
      </b-row>
      <b-row class="border-bottom pb-3">
        <b-col md="8" class="mx-auto">
          <div class="mt-3" align-h="start">
            <b-table
              id="tblCRAConfiguration"
              class="text-center"
              hover
              striped
              bordered
              responsive="sm"
              :items="cras"
              :fields="craTableHeaders"
            >
              <template v-slot:cell(report)="row">
                <b-form-group class="mb-0">
                  <b-form-checkbox
                    v-if="row.item.title === 'XP'"
                    v-model="xp"
                    name="xp"
                    :value="row.item.report"
                    :disabled="disableXP"
                    @change="onChangeReport(row.item.report)"
                  ></b-form-checkbox>

                  <b-form-checkbox
                    v-if="row.item.title === 'TU'"
                    v-model="tu"
                    name="tu"
                    :value="row.item.report"
                    :disabled="disableTU"
                    @change="onChangeReport(row.item.report)"
                  ></b-form-checkbox>

                  <b-form-checkbox
                    v-if="row.item.title === 'EQ'"
                    v-model="eq"
                    name="eq"
                    :value="row.item.report"
                    :disabled="disableEQ"
                    @change="onChangeReport(row.item.report)"
                  ></b-form-checkbox>
                </b-form-group>
              </template>
              <template v-slot:cell(score)="row">
                <b-form-group class="mb-0">
                  <b-form-checkbox
                    v-if="row.item.title === 'XP'"
                    v-model="xp"
                    name="xp"
                    :value="row.item.score"
                    :disabled="disableXP"
                    @change="onChangeScore(row.item.score)"
                  ></b-form-checkbox>

                  <b-form-checkbox
                    v-if="row.item.title === 'TU'"
                    v-model="tu"
                    name="tu"
                    :value="row.item.score"
                    :disabled="disableTU"
                    @change="onChangeScore(row.item.score)"
                  ></b-form-checkbox>

                  <b-form-checkbox
                    v-if="row.item.title === 'EQ'"
                    v-model="eq"
                    name="eq"
                    :value="row.item.score"
                    :disabled="disableEQ"
                    @change="onChangeScore(row.item.score)"
                  ></b-form-checkbox>
                </b-form-group>
              </template>
              <template v-slot:cell(fraud)="row">
                <b-form-group class="mb-0">
                  <b-form-checkbox
                    v-if="row.item.title === 'XP'"
                    v-model="xp"
                    name="xp"
                    :value="row.item.fraud"
                    :disabled="disableXP"
                    @change="onChangeFraud(row.item.fraud)"
                  ></b-form-checkbox>

                  <b-form-checkbox
                    v-if="row.item.title === 'TU'"
                    v-model="tu"
                    name="tu"
                    :value="row.item.fraud"
                    :disabled="disableTU"
                    @change="onChangeFraud(row.item.fraud)"
                  ></b-form-checkbox>
                </b-form-group>
              </template>
            </b-table>
            <b-col>
              <div v-if="showBureauError === true" class="error">
                The Score/ Fraud should be selected along with a Report
              </div>
            </b-col>
          </div>
        </b-col>
      </b-row>

      <b-row align-h="start" class="my-3">
        <b-col md="2">
          <BaseEButton type="submit" :disabled="disableOrderBtn">
            Order
          </BaseEButton>
        </b-col>
      </b-row>
    </b-form>
    <BaseModalLayout
      :show-modal="showConfirm"
      modal-title="Upload Authorization Form"
      modal-size="md"
      ok-variant="Yes and Continue"
      cancel-variant="Close"
      :hide-ok="true"
      @confirmCancelClicked="showConfirm = false"
    >
      <b-row class="pt-3">
        <b-col>
          <BaseELabel
            label="Upload file ( Support .pdf and .tiff Formats) Max size is 2 MB"
          />
        </b-col>
      </b-row>
      <b-row class="pb-4">
        <b-col>
          <div class="d-block text-center">
            <div>
              <b-form-file
                id="signedfile"
                ref="file-input"
                v-model="signedfile"
                :validate="'required'"
                accept="application/pdf, image/tiff, image/tif"
                placeholder="example_filename.pdf"
                drop-placeholder="Drop file here..."
                class="text-left"
                :class="$style.textellipsis"
                @change.native="onChangePdf"
              ></b-form-file>
            </div>
          </div>
        </b-col>
      </b-row>
    </BaseModalLayout>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.input {
  display: block;
  width: 100%;
  margin-bottom: $size-grid-padding;
  background-color: $color-content-bg;
  border: $size-input-border solid $color-input-border;
  border-radius: $size-input-border-radius;
}
.labelSubHeading {
  margin-left: -2rem;
  font-size: $size-content-font;
  font-weight: 500;
  color: $color-text-gray;
}

.textellipsis {
  padding-right: 84px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
table > tbody > tr > td {
  text-align: center;
  // vertical-align: center;
}
</style>
